import { render, staticRenderFns } from "./customGoods.vue?vue&type=template&id=fcbef0d8&scoped=true&"
import script from "./customGoods.vue?vue&type=script&lang=js&"
export * from "./customGoods.vue?vue&type=script&lang=js&"
import style0 from "./customGoods.vue?vue&type=style&index=0&id=fcbef0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbef0d8",
  null
  
)

export default component.exports